//#region Libraries
import { useState } from "react";
//#endregion
//#region Styles
import {
    Column, 
    Fields, 
    ParagraphSection, Part, 
    SubtitleSection, TitleSection } from "components/styles";
//#endregion
//#region Components
import SearchInDialogAlert from "components/SearchInDialogAlert/SearchInDialogAlert";
import Preloader from "components/Preloader/Preloader";
//#endregion
//#region Images
//#endregion
//#region Utils
//#endregion

const Part1 = ({
    form, changeField,
    errors, errorTexts,
    allAdvisers
}) => {
    const { adviser } = form;
    const [loadingPreloaderSearchAdvisers, setLoadingPreloaderSearchAdvisers] = useState(false);
    const [matchedAdviserList, setMatchedAdviserList] = useState([]);
    const [mostSimilarAdviser, setMostSimilarAdviser] = useState("");
    const [showDialogSearchAdviser, setShowDialogSearchAdviser] = useState(false);

    const toggleDialogSearchAdviser = (value = null) => {
        setShowDialogSearchAdviser(prev => value !== null ? value : !prev);
    }
    const changeSearchField = ({ id: code, text }) => {
        changeField("adviser", { code, fullName: text }, false);
    }
    const clearMatchedAdvisersList = () => setMatchedAdviserList([]);
    const fillMatchedAdviserList = strNameAdviser => {
        const data = allAdvisers.map(({ code, name }) => ({
            id: code, text: name
        }));
        const newMatchedData = !strNameAdviser
            ? [] 
            : data.filter(
                ({ text }) => 
                    text.toUpperCase()
                        .includes(strNameAdviser.toUpperCase())
        );
        setMatchedAdviserList(newMatchedData);
        if (strNameAdviser && newMatchedData.length === 0) {
            setMostSimilarAdviser(data.find(
                ({ text }) => (
                    text[0].toUpperCase() === strNameAdviser[0].toUpperCase()
                )
            )?.text || "");
        }
    }
    return (
        <Part>
            <Fields>
                <Column>
                    <TitleSection>Organización</TitleSection>   
                </Column>
                <Column>
                    <SubtitleSection fontSize="16px">Asesor a cargo</SubtitleSection>
                    <SearchInDialogAlert 
                        widthFoundField="300px"
                        buttonProps={{
                            text:"Buscar asesor",
                            variant:"secondary",
                            error: errors.adviser,
                            errorText: errorTexts.adviser,
                            width: "100%"
                        }}
                        label="Busca al asesor dando click en el boton"
                        placeholder="Escribe el nombre y apellido"
                        changeSearchField={changeSearchField}
                        clearData={clearMatchedAdvisersList}
                        data={matchedAdviserList}
                        fillData={fillMatchedAdviserList}
                        titleDialog="Buscar al asesor"
                        mostSimilar={mostSimilarAdviser}
                        firstSelection={adviser.code}
                        name={adviser.fullName}
                        showDialogAlert={showDialogSearchAdviser}
                        toggleDialogAlert={toggleDialogSearchAdviser}
                        notFoundMessage="El nombre que estás buscando no está en la lista de docentes."
                        notFoundSubmessage="*Si el nombre no está en la lista, puedes escribirlo manualmente."
                    />
                    <Preloader 
                        message="Buscando asesores..."
                        hidden={!loadingPreloaderSearchAdvisers}
                    />
                </Column>
            </Fields>
        </Part>
    );
}

export default Part1;